(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aloize-alliance-stores"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.aloizeAllianceTrackingReady) return;
    window.aloizeAllianceTrackingReady = true;

    const eventByAction = {
      choose_store: 'store_select',
      directions: 'directions_click',
      call: 'phone_click',
      store_details: 'store_details'
    };

    document.addEventListener('click', (event) => {
      if (!document.querySelector('[data-aloize-alliance-page]')) return;

      let link = event.target.closest('[data-aloize-action]');
      let action = link?.dataset.aloizeAction;
      let store = link?.dataset.aloizeStore || 'all';

      if (!link) {
        link = event.target.closest('a[href="#boutiques"]');
        if (!link) return;
        action = 'choose_store';
      }

      const eventName = eventByAction[action];
      if (!eventName) return;

      const payload = {
        event: eventName,
        aloize_action: action,
        aloize_store: store,
        aloize_destination: link.getAttribute('href') || ''
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('aloize:store-action', { detail: payload }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aloize-product-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aloize-product-journey')) {
    class AloizeProductJourney extends HTMLElement {
      connectedCallback() {
        const dataElement = this.querySelector('[data-aloize-journey-variants]');
        if (!dataElement) return;

        try {
          this.variantData = new Map(
            JSON.parse(dataElement.textContent).map((variant) => [String(variant.id), variant])
          );
        } catch (error) {
          return;
        }

        this.handleVariantChange = this.handleVariantChange.bind(this);
        document.addEventListener('variant:change', this.handleVariantChange);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this.handleVariantChange);
      }

      handleVariantChange(event) {
        const variantId = event.detail?.variant?.id;
        if (variantId == null) return;

        const variant = this.variantData.get(String(variantId));
        if (!variant) return;

        const sku = this.querySelector('[data-aloize-journey-sku]');
        const availability = this.querySelector('[data-aloize-journey-availability]');

        if (sku) sku.textContent = variant.sku || '';
        const reference = this.querySelector('[data-aloize-journey-reference]');
        if (reference) reference.hidden = !variant.sku;
        if (availability) availability.textContent = variant.availability;
      }
    }

    customElements.define('aloize-product-journey', AloizeProductJourney);
  }

  if (!customElements.get('aloize-product-recommendations')) {
    class AloizeProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true' || this.querySelector('[data-recommendations-content]')) return;

        this.dataset.initialized = 'true';
        this.loadRecommendations = this.loadRecommendations.bind(this);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.observer.disconnect();
              this.loadRecommendations(this.dataset.intent || 'complementary');
            },
            { rootMargin: '0px 0px 320px 0px' }
          );
          this.observer.observe(this);
        } else {
          this.loadRecommendations(this.dataset.intent || 'complementary');
        }
      }

      async loadRecommendations(intent) {
        try {
          const url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('product_id', this.dataset.productId);
          url.searchParams.set('limit', this.dataset.limit || '4');
          url.searchParams.set('intent', intent);

          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);

          const wrapper = document.createElement('div');
          wrapper.innerHTML = await response.text();
          const content = wrapper.querySelector('[data-recommendations-content]');

          if (content) {
            this.replaceChildren(content.cloneNode(true));
            this.setAttribute('aria-busy', 'false');
            return;
          }

          if (intent === 'complementary') {
            await this.loadRecommendations('related');
            return;
          }

          this.remove();
        } catch (error) {
          this.remove();
        }
      }
    }

    customElements.define('aloize-product-recommendations', AloizeProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
